import React, { Component }  from 'react';
import { Row, Col} from 'antd'

// personal component
import NewRadio from '../radio';
import StemTemplate from './stem';

class StemEditor extends Component {
    // 题干段落发生变化
    handleOptionChange = num => {
        const { onOptionChange } = this.props;
        onOptionChange && onOptionChange(num)
    }
    // 段落样式发生变化
    handleStemStyleChange = (value, index) => {
        const { onStemStyleChange } = this.props;
        onStemStyleChange && onStemStyleChange(value, index);
    }

    // 内容输入方式改变
    handleContentInputChange = (value, index) => {
        const { onContentInputStyleChange } = this.props;
        onContentInputStyleChange && onContentInputStyleChange(value, index);
    }

    // 更改题干列表
    handleEdittStemList = data => {
        const { onEdittStemList } = this.props;
        onEdittStemList && onEdittStemList(data);
    }

    render() {
        const { optionNum, maxOptionNum, stemStyle, selectStemStyle, contentInputType, contentInputStype, stemList, subject, guideList, isSetDefaultGuide, isShowGetGuide, guideCurrentStem } = this.props;
        return (
            <div>
                <Row className="content-tml-row-public" type="flex" align="middle">
                    <Col span={2} className="content-tml-public-name">题干：</Col>
                    <Col span={22} className="stem-detail">
                        <label>段落个数&nbsp;&nbsp;&nbsp;&nbsp;</label>
                        <NewRadio
                            optionNum={optionNum}
                            maxOptionNum={maxOptionNum}
                            onOptionChange={this.handleOptionChange}
                        />
                    </Col>
                </Row>
                <StemTemplate 
                    optionNum={optionNum}
                    subject={subject}
                    stemStyle={stemStyle}
                    selectStemStyle={selectStemStyle}
                    contentInputType={contentInputType}
                    contentInputStype={contentInputStype}
                    stemList={stemList}
                    guideList={guideList}
                    isSetDefaultGuide={isSetDefaultGuide}
                    isShowGetGuide={isShowGetGuide}
                    guideCurrentStem={guideCurrentStem}
                    onStemStyleChange={this.handleStemStyleChange}
                    onContentInputStyleChange={this.handleContentInputChange}
                    onEdittStemList={this.handleEdittStemList}
                    onOptionChange={this.handleOptionChange}
                />
            </div>
        )
    }
}

export default StemEditor;


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_tml/components/stem_editor/view.js